export function capitalize(str: string) {
  return str.replace(str[0], str[0].toUpperCase())
}
